module.exports = __webpack_public_path__ + "media/public/img/icons-user-19e9add822b2c3bf2970243c56160446.png";